import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function ForYouNotForYou() {
  const forYou = ["You want a plan that doesn't involve a screen", "You've been looking for something different to do with your partner", 'Your friend group needs a real night out — without leaving home', "You love true crime and you've always wanted to be on the other side of it", 'You want to actually use your brain for something fun', "You're tired of the same dinner-and-a-movie routine"];
  const notForYou = ["You're looking for something passive", 'You want an experience that requires zero effort', "You're not willing to argue with your friends about a suspect for 45 minutes"];
  return <section className="py-16 sm:py-24 lg:py-32 bg-[#121212] relative" data-id="element-149">
      <div className="absolute inset-0 bg-noise opacity-10 mix-blend-overlay pointer-events-none" data-id="element-150" />
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-151">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-12" data-id="element-152">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#ece3d0] bg-paper-texture rounded shadow-xl p-6 sm:p-10 border border-[#d4c5b0]" data-id="element-153">
            <h3 className="font-typewriter text-2xl sm:text-3xl text-[#1a1a1a] mb-5 sm:mb-8 font-bold border-b-2 border-[#1a1a1a] pb-3 sm:pb-4" data-id="element-154">
              This is for you if —
            </h3>
            <div className="space-y-4 sm:space-y-6" data-id="element-155">
              {forYou.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="flex items-start space-x-4" data-id="element-156">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-green-900/10 flex items-center justify-center shrink-0 mt-1 border border-green-900/20" data-id="element-157">
                    <CheckIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-green-800" data-id="element-158" />
                  </div>
                  <span className="font-serif-body text-[#2a2a2a] text-base sm:text-xl leading-relaxed" data-id="element-159">
                    {item}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#0a0a0a] border border-[#8b1a1a]/30 rounded shadow-xl p-6 sm:p-10 relative overflow-hidden" data-id="element-160">
            <div className="absolute inset-0 bg-[#8b1a1a]/5" data-id="element-161" />
            <h3 className="relative z-10 font-typewriter text-2xl sm:text-3xl text-[#ece3d0] mb-5 sm:mb-8 font-bold border-b-2 border-[#8b1a1a]/30 pb-3 sm:pb-4" data-id="element-162">
              This is not for you if —
            </h3>
            <div className="relative z-10 space-y-4 sm:space-y-6" data-id="element-163">
              {notForYou.map((item, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="flex items-start space-x-4" data-id="element-164">
                  <div className="w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-red-900/20 flex items-center justify-center shrink-0 mt-1 border border-red-900/30" data-id="element-165">
                    <XIcon className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-[#8b1a1a]" data-id="element-166" />
                  </div>
                  <span className="font-serif-body text-[#ece3d0]/80 text-base sm:text-xl leading-relaxed" data-id="element-167">
                    {item}
                  </span>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}